import { Pipe, PipeTransform } from '@angular/core';
import get from 'lodash-es/get';
import { GetSimpleDatePipe } from './get-simple-date.pipe';

@Pipe({ name: 'getDayInData' })
export class GetDayInDataPipe implements PipeTransform {

    constructor(private getSimpleDatePipe: GetSimpleDatePipe) {}

    transform(calendarObject: any, dayData: any, day: number, prop: string): any {
        const simpleDate: string = this.getSimpleDatePipe.transform(calendarObject, day);

        return get(dayData, `${simpleDate}.${prop}`);
    }
}
